var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('create-card',{attrs:{"route_back":"ClientList","model_name":"cliente","saving":_vm.saving,"loading":_vm.loading.checking_client}},[_c('template',{slot:"form"},[_c('ClientInfoStepper',{ref:"form0",staticClass:"pa-1",attrs:{"client":_vm.client},on:{"saveClient":_vm.handleSaveClient}})],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }